var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vw-form-flight"},[_c('div',{staticClass:"vw-form-flight-icon",on:{"click":function($event){return _vm.toggleFlights()}}},[_c('iconTudaSuda')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }